import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/rollen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="Role"
      returnRoute="/auswahlfelder/roles"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const RolesRoute = Route;
